/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ price: NonNullable<unknown> }} Plan_Choice_Price_Per_MonthInputs */

const fr_plan_choice_price_per_month = /** @type {(inputs: Plan_Choice_Price_Per_MonthInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.price} / mois`)
};

/**

* @param {Plan_Choice_Price_Per_MonthInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const plan_choice_price_per_month = /** @type {((inputs: Plan_Choice_Price_Per_MonthInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Choice_Price_Per_MonthInputs, { locale?: "fr" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_plan_choice_price_per_month(inputs)
});